<template>
  <div class="tw-relative">
    <history-common
      v-if="selectedDomain"
      :tier="tierType"
      :tier_id="selectedDomain.id"
      class="tw-mb-6"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import HistoryCommon from "@/views/Common/History";

import { TIER } from "@/constants";

export default {
  components: {
    HistoryCommon,
  },
  data() {
    return {
      loading: false,
      tierType: TIER.domains,
    };
  },
  methods: {
    ...mapActions("pageMeta", ["setPageTitle", "setPageSubtitle"]),
  },
  computed: {
    ...mapGetters("authentication", ["selectedDomain"]),
  },

  async mounted() {
    this.setPageTitle(this.$t("History"));
    this.setPageSubtitle([
      this.$t(
        "Search and view recent messages for your domains to troubleshoot in realtime"
      ),
    ]);
    if (!this.selectedDomain) {
      this.$router.push("/logout");
    }
  },
};
</script>
